var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-500 text-large"},[_c('div',{staticClass:"error-500__message"},[_vm._v("500エラーが発生しました。")]),_c('a',{attrs:{"href":_vm.topPage}},[_vm._v("戻る")])])
}
var staticRenderFns = []

export { render, staticRenderFns }